import { useTheme } from '../../context/ThemeContext.jsx';
import { useAuth } from '../../context/AuthContext.jsx';

export default function HeaderBar({ activatedCount, totalSyncedSize, teamMembers, onToggleTheme, onShowUserManagement }) {
  const { theme, isDark } = useTheme();
  const { user, logout } = useAuth();

  return (
    <header style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '0 24px', height: 56,
      borderBottom: `1px solid ${theme.border}`,
      background: theme.headerBg,
      backdropFilter: 'blur(20px)',
      position: 'sticky', top: 0, zIndex: 100,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <img src='/favicon.png' alt='R' style={{ width: 28, height: 28, borderRadius: 6 }} />
        <span style={{ fontSize: 15, fontWeight: 700, letterSpacing: '-0.02em' }}>Riester Fonts</span>
        <span style={{
          fontSize: 10, fontWeight: 600, color: theme.purple,
          background: theme.purpleBg, padding: '2px 8px', borderRadius: 10,
          letterSpacing: '0.05em', textTransform: 'uppercase',
        }}>Riester</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8,
          fontSize: 12, color: theme.textTertiary,
        }}>
          <span style={{
            width: 7, height: 7, borderRadius: '50%',
            background: theme.green, display: 'inline-block',
            boxShadow: `0 0 8px ${theme.green}66`,
          }} />
          {activatedCount} active · {totalSyncedSize} synced
        </div>

        <a
          href="/download"
          title="Download Desktop Agent"
          style={{
            background: theme.bgInput, border: `1px solid ${theme.borderMedium}`,
            borderRadius: 6, color: theme.textMuted,
            padding: "5px 8px", cursor: "pointer", fontSize: 14,
            textDecoration: "none", display: "inline-flex", alignItems: "center",
          }}
        >{"⬇"}</a>

        <button
          onClick={onToggleTheme}
          title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
          style={{
            background: theme.bgInput, border: `1px solid ${theme.borderMedium}`,
            borderRadius: 6, color: theme.textMuted,
            padding: '5px 8px', cursor: 'pointer', fontSize: 14,
          }}
        >{isDark ? '☀' : '☾'}</button>

        <div
          onClick={onShowUserManagement}
          title="Manage team"
          style={{ display: 'flex', cursor: 'pointer' }}
        >
          {teamMembers.slice(0, 4).map((t, i) => (
            <div key={t.id || i} title={t.name} style={{
              width: 26, height: 26, borderRadius: '50%',
              background: t.color || '#4F8EF7',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 9, fontWeight: 700, color: '#fff',
              border: `2px solid ${theme.bg}`,
              marginLeft: i > 0 ? -6 : 0,
              position: 'relative', zIndex: teamMembers.length - i,
            }}>{t.initials || t.name?.slice(0, 2).toUpperCase()}</div>
          ))}
          {teamMembers.length > 4 && (
            <div style={{
              width: 26, height: 26, borderRadius: '50%',
              background: theme.bgInput,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 10, color: theme.textMuted,
              border: `2px solid ${theme.bg}`, marginLeft: -6,
            }}>+{teamMembers.length - 4}</div>
          )}
        </div>

        <button
          onClick={logout}
          title="Sign out"
          style={{
            background: theme.bgInput, border: 'none',
            borderRadius: 6, color: theme.textTertiary,
            padding: '5px 10px', cursor: 'pointer', fontSize: 11,
            fontFamily: 'inherit',
          }}
        >{user?.initials || '??'} ⏻</button>
      </div>
    </header>
  );
}
